module.exports = __webpack_public_path__ + "img/goldschmiede.292c3e44.jpg";